<template>
    <div class="layout--default">
        <LayoutLoader :is-loading="$store.state.isLoading" />
        <div class="layout-default-wrapper">
            <router-view></router-view>
        </div>

    </div>
</template>

<script>
    import LayoutLoader from '@/components/layout/LayoutLoader'
    export default {
        name: "DefaultLayout",
        components: {LayoutLoader}
    }
</script>

<style lang="scss">
    .layout-default {
        &-wrapper {
            height: 100vh;

        }
    }
</style>
